module.exports = __webpack_public_path__ + "static/media/thumbnail.6b825fc0.png";